import client from "./client";

export const myWallet = async () => (await client.get("/wallet/me")).data;
export const walletTransactions = async (limit = 50) =>
  (await client.get("/wallet/transactions", { params: { limit } })).data;
export const walletAlerts = async () => (await client.get("/wallet/alerts")).data;
export const startTopup = async (tokens) =>
  (await client.post("/wallet/topup", { tokens, origin_url: window.location.origin })).data;

export const walletAutopay = async () => (await client.get("/wallet/autopay")).data;
export const saveWalletAutopay = async (body) => (await client.put("/wallet/autopay", body)).data;
export const startCardSetup = async () =>
  (await client.post("/wallet/autopay/card", { origin_url: window.location.origin })).data;

export const tokenOverview = async () => (await client.get("/platform/tokens/overview")).data;
export const tokenPricing = async () => (await client.get("/platform/token-pricing")).data;
export const saveTokenPricing = async (body) => (await client.put("/platform/token-pricing", body)).data;
